import { render, staticRenderFns } from "./bindResult.vue?vue&type=template&id=0ee7aea8&scoped=true"
import script from "./bindResult.vue?vue&type=script&lang=js"
export * from "./bindResult.vue?vue&type=script&lang=js"
import style0 from "./bindResult.vue?vue&type=style&index=0&id=0ee7aea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7aea8",
  null
  
)

export default component.exports